import get from 'lodash.get';
import createCachedSelector from 're-reselect';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const selectInventory = (state) => get(state, 'inventory', emptyArray);
const selectProducts = (state) => get(state, 'products', emptyObject);
export const selectProductsById = (state, props) => get(selectProducts(state, props), props.productId);

const selectReportingCategories = (state) => get(state, 'reportingCategories', emptyObject);
const selectReportingCategoryById = (state, props) => get(selectReportingCategories(state, props), props.categoryId);
export const selectReportingCategoryPropertyById = (state, props) => get(selectReportingCategoryById(state, props), props.property);

export const selectProductProfiles = (state) => get(state, 'productProfiles', emptyObject);
export const selectProductProfileById = (state, props) => get(selectProductProfiles(state), props.productProfileId);

const selectPresetGroups = (state) => selectProductProfiles(state);
export const selectPresetGroupById = (state, props) => get(selectPresetGroups(state, props), props.profileId);
export const selectPresetGroupPropertyById = (state, props) => get(selectPresetGroupById(state, props), props.property);

export const selectProductsByIds = createCachedSelector(
  selectProducts,
  (_, props) => JSON.stringify(props.productIds),
  (products, productIdsJSON) => {
    const productIds = JSON.parse(productIdsJSON);

    if (productIds.length === 0) {
      return emptyArray;
    }

    return productIds.map((productId) => products[productId]);
  },
)((_, props) => JSON.stringify(props.productIds));

export const selectInventoryByProductIds = createCachedSelector(
  selectInventory,
  (_, props) => JSON.stringify(props.productIds),
  (inventory, productIdsJSON) => {
    const productIds = JSON.parse(productIdsJSON);
    if (productIds.length === 0) {
      return emptyArray;
    }

    const inventoryIds = Object.keys(inventory);

    return inventoryIds.reduce((acc, inventoryId) => {
      const inventoryLocation = inventory[inventoryId];
      if (productIds.includes(inventoryLocation.productId)) {
        return [...acc, inventoryLocation];
      }

      return acc;
    }, []);
  },
)((_, props) => JSON.stringify(props.productIds));
